import { render, staticRenderFns } from "./ProblemVerificationForm222.vue?vue&type=template&id=1168e1dd&scoped=true"
import script from "./ProblemVerificationForm222.vue?vue&type=script&lang=js"
export * from "./ProblemVerificationForm222.vue?vue&type=script&lang=js"
import style0 from "./ProblemVerificationForm222.vue?vue&type=style&index=0&id=1168e1dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1168e1dd",
  null
  
)

export default component.exports